import { render, staticRenderFns } from "./TarimaDevolucionComponent.vue?vue&type=template&id=637199e3&"
import script from "./TarimaDevolucionComponent.vue?vue&type=script&lang=js&"
export * from "./TarimaDevolucionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports